import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';

const propTypes = {};

function FormattedPrice({ perMonth, perYear, value, noCents, ...props }) {
  return (
    <>
      <FormattedNumber
        minimumFractionDigits={perMonth || perYear || noCents ? 0 : 2}
        maximumFractionDigits={perMonth || perYear || noCents ? 0 : 2}
        {...props}
        value={value / 100}
        currency="USD"
        style="currency" // eslint-disable-line react/style-prop-object
      />
      {perMonth && (
        <FormattedMessage id="formattedPrice.perMonth" defaultMessage="/mo" />
      )}
      {perYear && (
        <FormattedMessage id="formattedPrice.perYear" defaultMessage="/yr" />
      )}
    </>
  );
}

FormattedPrice.propTypes = propTypes;

export default FormattedPrice;
